/**
 * Initials for an avatar: the first and last words' first letters, upper-cased
 * (e.g. "Jordan Pierce" → "JP", "Cher" → "C"). Returns `null` when there is
 * nothing to derive from, so callers can fall back to a neutral avatar.
 */
export function initialsFor(name: string | null | undefined): string | null {
  if (name == null) return null;
  const words = name.trim().split(/\s+/).filter((word) => word.length > 0);
  const first = words[0];
  if (first === undefined) return null;
  const last = words.length > 1 ? (words[words.length - 1] ?? '') : '';
  return (first.charAt(0) + last.charAt(0)).toUpperCase();
}
